import { render, staticRenderFns } from "./ReservationsTable.vue?vue&type=template&id=1fa1f7a8&scoped=true&"
import script from "./ReservationsTable.vue?vue&type=script&lang=js&"
export * from "./ReservationsTable.vue?vue&type=script&lang=js&"
import style0 from "./ReservationsTable.vue?vue&type=style&index=0&id=1fa1f7a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa1f7a8",
  null
  
)

export default component.exports